import { motion } from "framer-motion";
import { SITE } from "../constants/site";

export default function Preloader() {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] bg-[#FBFAF7] flex flex-col items-center justify-center"
      exit={{ y: "-100%", transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] } }}
    >
      <motion.img
        src={SITE.mark}
        alt="Sugee Group"
        className="h-20 w-20 rounded-full object-cover shadow-lg"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="overflow-hidden mt-6">
        <motion.p
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ delay: 0.25, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-xl md:text-2xl tracking-[0.4em] text-foreground"
        >
          SUGEE LAKE DISTRICT
        </motion.p>
      </div>
      <motion.div
        className="mt-6 h-px bg-primary origin-left"
        style={{ width: 180 }}
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ delay: 0.4, duration: 1.1, ease: "easeInOut" }}
      />
    </motion.div>
  );
}
